import React from "react";

//Fades its content in when it scrolls into view (Wix's "Fade In" entrance on the home page).
//Shown straight away for visitors who prefer reduced motion, or in browsers without IntersectionObserver
const Reveal = ({ as: Tag = "div", className = "", delay = 0, children }) => {
  const ref = React.useRef(null);
  const [isShown, setIsShown] = React.useState(false);

  React.useEffect(() => {
    const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      setIsShown(true);
      return undefined;
    }
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        setIsShown(true);
        observer.disconnect();
      }
    }, { rootMargin: "0px 0px -12% 0px" });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`reveal ${isShown ? "is-shown" : ""} ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
